import React from 'react';

import { normalizeUrl } from '../../utils/helpers';
import styles from './styles.module.scss';

type VideoProps = { videoUrl: string };

export const VideoPreview: React.FC<VideoProps> = ({ videoUrl }) => {
  const style = {
    height: '351px',
    width: '100%',
  };

  return (
    <div className={styles.aspectRatio}>
      <iframe
        title = "Video Preview"
        src={normalizeUrl(videoUrl)}
        style={style}
      />
    </div>
  );
};
